import { render, staticRenderFns } from "./PhotoRelease.vue?vue&type=template&id=29b98f9b&scoped=true&"
import script from "./PhotoRelease.vue?vue&type=script&lang=js&"
export * from "./PhotoRelease.vue?vue&type=script&lang=js&"
import style0 from "./PhotoRelease.vue?vue&type=style&index=0&id=29b98f9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b98f9b",
  null
  
)

export default component.exports